/*
 * Code
 */

import * as L from 'leaflet';
import 'leaflet-ajax';
import 'leaflet.fullscreen/Control.FullScreen.js';

import '@fortawesome/fontawesome-free/js/brands';
import '@fortawesome/fontawesome-free/js/solid';
import '@fortawesome/fontawesome-free/js/fontawesome';

import "./burger.js";
import "./hikesummary.js";
import "./map.js";


/*
 * Styles
 */

require('./../css/bulma-styles.scss');

import './../css/alsnuff-styles.css';

import 'leaflet/dist/leaflet.css';
import 'leaflet.fullscreen/Control.FullScreen.css';